import { Box, styled } from "@mui/material";
import React from "react";
import { Rocket } from "@mui/icons-material";

const ComingSoon = () => {
  return (
    <BgWrapper>
      <Wrapper>
        <span
          className="rocket"
          role="img"
          aria-label="Rocket"
          style={{ fontSize: "3rem" }}
        >
          <Rocket sx={{ fontSize: "5rem" }} />
        </span>
        <h2>Something Exciting is Coming Your Way!</h2>
        <h3>We're working on something special. Stay tuned!</h3>
        <h4>
          Our team is hard at work crafting an experience that will delight and
          inspire you.
          <br />
          We can't wait to share it with you. Check back soon for updates!
        </h4>
      </Wrapper>
    </BgWrapper>
  );
};

export default ComingSoon;

const BgWrapper = styled(Box)`
  min-height: 60vh;
  display: flex;
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 50%, #90caf9 50%);
  animation: fadeIn 1.2s ease;
  margin-top: 20px;
  padding: 20px;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (max-width: 600px) {
    padding: 12px;
    margin-top: 12px;
  }
`;

const Wrapper = styled(Box)`
  background-color: #fff;
  border-radius: 16px;
  color: #444;
  text-align: center;
  padding: 3rem 5rem;
  box-shadow: 0 8px 32px rgba(60, 120, 180, 0.12);
  max-width: 500px;
  width: 100%;
  
  h2 {
    color: #2e7d32;
    font-size: 2.2rem;
    font-weight: 700;
    margin-bottom: 16px;
    letter-spacing: 1px;
  }
  h3 {
    color: #1976d2;
    font-size: 1.3rem;
    margin-bottom: 12px;
    font-weight: 500;
  }
  h4 {
    margin: 18px auto 10px auto;
    font-size: 1.1rem;
    color: #666;
    line-height: 1.6;
  }
  .rocket {
    display: block;
    margin-bottom: 18px;
    animation: bounce 1.5s infinite;
  }
  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-12px);
    }
  }

  @media (max-width: 768px) {
    padding: 2.5rem 2rem;
  }

  @media (max-width: 600px) {
    padding: 2rem 1.5rem;
    max-width: 95%;
    
    h2 {
      font-size: 1.4rem;
    }
    h3 {
      font-size: 1.05rem;
    }
    h4 {
      font-size: 0.95rem;
    }
    .rocket {
      font-size: 2.5rem !important;
      
      svg {
        font-size: 4rem !important;
      }
    }
  }
`;